import React from "react";
import { Field } from "redux-form";
import { ReduxControls } from "rhombus-react";
import { useTooltipRebuild } from "hooks/useTooltipRebuild";

import "./FeedSettings.css";

const AUTO_MAPPING_TOOLTIP = "Mapping is done automatically based on the available versions in the selected creatives";
const AUTO_UPDATES_TOOLTIP = "Auto Updates are handled automatically and cannot be changed";

function FeedSettings({ isAssignBlankFlow, isAssignFlow }) {
	const shouldDisableAutoUpdates = isAssignBlankFlow || isAssignFlow;
	const shouldDisableAutoMapping = isAssignBlankFlow || isAssignFlow;
	useTooltipRebuild(shouldDisableAutoUpdates);

	return (
		<div className="form-field">
			<label className="feed-settings-label">Bulk Sheet Settings</label>
			<div className={shouldDisableAutoUpdates ? "auto-updates-tooltip-wrapper" : undefined}
				{...(shouldDisableAutoUpdates && {
					'data-tip': AUTO_UPDATES_TOOLTIP,
					'data-place': 'top',
					'data-class': 'auto-updates-tooltip',
				})}>
				<Field
					name="autoUpdates"
					type="checkbox"
					component={ReduxControls.Checkbox}
					className="inverted-check"
					label="Auto Updates"
					disabled={shouldDisableAutoUpdates}
				/>
			</div>
			<div className={shouldDisableAutoMapping ? "auto-mapping-tooltip-wrapper" : undefined}
				{...(shouldDisableAutoMapping && {
					'data-tip': AUTO_MAPPING_TOOLTIP,
					'data-place': 'top',
					'data-class': 'auto-mapping-tooltip',
				})}>
				<Field
					name="autoMapping"
					type="checkbox"
					component={ReduxControls.Checkbox}
					className="inverted-check"
					label="Auto Mapping"
					disabled={shouldDisableAutoMapping}
				/>
			</div>
		</div>
	);
}

export default FeedSettings;
